module.exports = __webpack_public_path__ + "img/sm-linkedin.3e06e558.svg";